import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../Context/AuthContext";
import { Button, Spinner } from "react-bootstrap";
import { Base_URL } from "../url";
import { toast } from "react-toastify";

const Attendance = ({
  onClock,
  loading,
  disableActions,
  showGeoWarning,
  isReady,
  distance,
  unit,
   attendanceStatus
}) => {
  const { user } = useAuth();

  // const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);
  // const [attendanceStatus, setAttendanceStatus] = useState();
  const [location, setLocation] = useState({
    latitude: null,
    longitude: null,
    address: null,
    cityOrigin: null,
  });

  // 📍 Get Location
  const getLocation = () => {
    if (!navigator.geolocation) {
      toast.error("Geolocation not supported");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const lat = position.coords.latitude;
        const lon = position.coords.longitude;

        try {
          const geoRes = await axios.get(
            `https://api.geoapify.com/v1/geocode/reverse?lat=${lat}&lon=${lon}&apiKey=ac8a8a05e1194e3a8f0c5a3872610ab1`
          );

          const props = geoRes.data?.features?.[0]?.properties;

          setLocation({
            latitude: lat,
            longitude: lon,
            address: props?.formatted || "Unknown",
            cityOrigin: props?.city || props?.county || "Unknown",
          });
        } catch {
          toast.error("Unable to fetch city");
        }
      },
      () => toast.error("Please enable location access"),
      { enableHighAccuracy: true, timeout: 10000 }
    );
  };

  useEffect(() => {
    getLocation();
  }, []);

  const handleClock = async (type) => {
    try {
      // setLoading(true);


      const now = new Date();

      const payload = {
        userId: user?.userId,
        Date: now.toISOString().split("T")[0],
        Time: now.toLocaleTimeString("en-GB", { hour12: false }),
        type,
        organisationId: user?.organisationId,
        latitude: String(location.latitude),
        longitude: String(location.longitude),
        address: location.address,
        city: location.cityOrigin,
        distanceFromStation:distance,
        distanceFromStationUnit:unit
      };

      const endpoint =
        type === "clock_in"
          ? `${Base_URL}/Attendance/clockIn`
          : `${Base_URL}/Attendance/clockOut`;

      await axios.post(endpoint, payload);

      toast.success(
        type === "clock_in"
          ? "Clocked In Successfully"
          : "Clocked Out Successfully"
      );

      setStatus(
        type === "clock_in"
          ? "You have successfully clocked in."
          : "You have successfully clocked out."
      );
    } catch {
      setStatus("Error while clocking. Try again.");
    } finally {
      // setLoading(false);
    }
  };

  // const getAttendanceStatus = async () => {
  //   const res = await axios.get(
  //     `${Base_URL}/Attendance/GetAttendanceStatus/id?id=${user?.userId}`
  //   );
  //   setAttendanceStatus(res.data);
  // };

  // useEffect(() => {
  //   getAttendanceStatus();
  // }, [status]);

  const isLocationAvailable = location.latitude && location.longitude;

  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        padding: "15px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        background: "#f6f8fc",
        borderRadius: "14px",
        overflow: "hidden", // 🚫 no scrolling
      }}
    >
      {/* HEADER */}
      <div>
        <h3 style={{ fontWeight: 600, marginBottom: "6px" }}>
          Attendance
        </h3>
        <p style={{ color: "#6c757d", marginBottom: "16px" }}>
          Logged in as <strong>{user?.username || "Unknown"}</strong>
        </p>
      </div>

      {/* LOCATION INFO */}
      <div
        style={{
          // background: "#ffffff",
          borderRadius: "12px",
          padding: "16px",
          boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
          fontSize: "14px",
        }}
      >
        <p style={{ marginBottom: "8px" }}>
          📍{" "}
          {isLocationAvailable
            ? `${location.latitude.toFixed(
                5
              )}, ${location.longitude.toFixed(5)}`
            : "Fetching coordinates..."}
        </p>
        <p style={{ marginBottom: "6px"}}>
          🏙️ City: {location.cityOrigin || "Fetching..."}
        </p>
        <p style={{ marginBottom: 0 }}>
          🏠 Address: {location.address || "Fetching..."}
        </p>
      </div>

      {/* WARNING */}
      {!isLocationAvailable && (
        <div
          style={{
            background: "#fff3cd",
            color: "#856404",
            padding: "10px",
            borderRadius: "10px",
            fontSize: "13px",
            marginTop: "16px",
          }}
        >
          ⚠️ Allow location access to clock in/out.
        </div>
      )}
      {showGeoWarning && (
  <div
    style={{
      background: "#fff3cd",
      color: "#856404",
      padding: "10px",
      borderRadius: "10px",
      fontSize: "13px",
      marginTop: "16px",
    }}
  >
    ⚠️ You are outside the geofence. Attendance will be marked with a warning.
  </div>
)}

      {/* ACTIONS */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: "16px",
          marginTop: "24px",
        }}
      >
<Button
  variant="success"
  disabled={
    !isReady ||
    loading ||
    disableActions ||
    attendanceStatus?.punchInStatus
  }
  onClick={() => onClock("clock_in")}
>
  Clock In
</Button>

<Button
  variant="danger"
  disabled={
    !isReady ||
    loading ||
    disableActions ||
    !attendanceStatus?.punchInStatus ||  // ⬅️ MUST clock in first
    attendanceStatus?.punchOutStatus     // ⬅️ disable after clock out
  }
  onClick={() => onClock("clock_out")}
>
  Clock Out
</Button>




      </div>

      {/* LOADER / STATUS */}
      {!isReady && (
  <div style={{ textAlign: "center", fontSize: "13px", color: "#6c757d" }}>
    Preparing attendance…
  </div>
)}

     <div style={{ textAlign: "center", marginTop: "16px" }}>
  {loading && <Spinner animation="border" size="sm" />}
        {status && (
          <p
            style={{
              marginTop: "10px",
              fontSize: "14px",
              fontWeight: 500,
              color: "#0d6efd",
            }}
          >
            {status}
          </p>
        )}
      </div>
    </div>
  );
};

export default Attendance;
